import { render, staticRenderFns } from "./SysMessage.vue?vue&type=template&id=3553b5bd&"
import script from "./SysMessage.vue?vue&type=script&lang=js&"
export * from "./SysMessage.vue?vue&type=script&lang=js&"
import style0 from "./SysMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SysMessage.vue"
export default component.exports